import styled from 'styled-components';

const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 100px;
  border: 1px solid transparent;
  transition: all .2s ease-in;

  &:hover {
    background: ${(props) => props.theme.colors.main_cta_light};
    color: ${(props) => props.theme.colors.main_cta};
  }
`;

const Download = styled.div`
  margin: 30px 0 60px 0;

  p {
    text-align: center;
  }

  button {
    padding: 10px;
    border: 1px solid ${(props) => props.theme.colors.red};
    border-radius: 50px;
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }

  .error {
    color: ${(props) => props.theme.colors.red};
  }
`;

export default { Wrapper, Download };
